import Parse from "papaparse";


export const convertCsvFileToJson = (file) => {
    return new Promise((resolve, reject) => {
        Parse.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                resolve(results.data);
            },
            error: (error) => {
                reject(error);
            },
        });
    });
};
